import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import Cabecalho from '../cabecalho/Cabecalho';
import Rodape from '../rodape/Rodape';
import Menu from '../menu/Menu';
import Titulo from '../titulo/Titulo';
import { listarAssuntosPorStatus, obterMensagem } from './mensagens';

const Suporte = () => {
    const [cadastrado, setCadastrado] = useState('Cadastrado');
    const [genero, setGenero] = useState('Homem');
    const [assuntoSelecionado, setAssuntoSelecionado] = useState('Redefinição de acesso — instruções enviadas');

    // Assuntos disponíveis de acordo com o status (cadastrado/sem cadastrado)
    const assuntosDisponiveis = useMemo(() => {
        const list = listarAssuntosPorStatus(cadastrado) || [];
        return list.slice().sort((a, b) => a.localeCompare(b, 'pt-BR', { sensitivity: 'base' }));
    }, [cadastrado]);

    // Garantir que o assunto selecionado sempre exista na lista atual
    React.useEffect(() => {
        if (!assuntosDisponiveis.includes(assuntoSelecionado)) {
            setAssuntoSelecionado(assuntosDisponiveis[0] || '');
        }
    }, [assuntosDisponiveis]);

    const assunto = assuntoSelecionado;
    const resposta = useMemo(
        () => obterMensagem({ status: cadastrado, genero, assunto }),
        [cadastrado, genero, assunto]
    );

    const [copied, setCopied] = useState(false);
    const [copiedAssunto, setCopiedAssunto] = useState(false);

    const copyResposta = async () => {
        if (!resposta) return;
        // Try navigator.clipboard first
        try {
            await navigator.clipboard.writeText(resposta);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
            return;
        } catch (e) {
            // fallback to execCommand
        }

        try {
            const ta = document.createElement('textarea');
            ta.value = resposta;
            // avoid showing the textarea
            ta.style.position = 'fixed';
            ta.style.left = '-9999px';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            // ignore
        }
    };

    const copyAssunto = async () => {
        if (!assunto) return;
        try {
            await navigator.clipboard.writeText(assunto);
            setCopiedAssunto(true);
            setTimeout(() => setCopiedAssunto(false), 2000);
            return;
        } catch (e) {}

        try {
            const ta = document.createElement('textarea');
            ta.value = assunto;
            ta.style.position = 'fixed';
            ta.style.left = '-9999px';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
            setCopiedAssunto(true);
            setTimeout(() => setCopiedAssunto(false), 2000);
        } catch (err) {
            // ignore
        }
    };

    return (
        <PageWrapper>
            <Menu />
            <Cabecalho />
            <MainContent>
                <Container>
                    <Titulo>Suporte - Mensagens Modelo</Titulo>
                    <FiltrosContainer>
                        <FiltroGroup>
                            <Label>Cadastrado:</Label>
                            <Select value={cadastrado} onChange={(e) => setCadastrado(e.target.value)}>
                                <option value="Cadastrado">Cadastrado</option>
                                <option value="Sem Cadastrado">Sem Cadastrado</option>
                            </Select>
                        </FiltroGroup>
                        <FiltroGroup>
                            <Label>Gênero:</Label>
                            <Select value={genero} onChange={(e) => setGenero(e.target.value)}>
                                <option value="Homem">Homem</option>
                                <option value="Mulher">Mulher</option>
                            </Select>
                        </FiltroGroup>
                        <FiltroGroup>
                            <Label>Assunto:</Label>
                            <Select
                                value={assuntoSelecionado}
                                onChange={(e) => setAssuntoSelecionado(e.target.value)}
                            >
                                {assuntosDisponiveis.map((a) => (
                                    <option key={a} value={a}>{a}</option>
                                ))}
                            </Select>
                        </FiltroGroup>
                    </FiltrosContainer>
                    <MensagemContainer>
                        <AssuntoContainer>
                            <RespostaHeader>
                                <AssuntoLabel>Assunto:</AssuntoLabel>
                                <CopyButton onClick={copyAssunto} aria-label="Copiar assunto">{copiedAssunto ? 'Copiado' : 'Copiar'}</CopyButton>
                            </RespostaHeader>
                            <AssuntoText>{assunto}</AssuntoText>
                        </AssuntoContainer>
                        <RespostaContainer>
                            <RespostaHeader>
                                <RespostaLabel>Resposta:</RespostaLabel>
                                <CopyButton onClick={copyResposta} aria-label="Copiar resposta">{copied ? 'Copiado' : 'Copiar'}</CopyButton>
                            </RespostaHeader>
                            <RespostaText>{resposta}</RespostaText>
                        </RespostaContainer>
                    </MensagemContainer>
                </Container>
            </MainContent>
            <Rodape />
        </PageWrapper>
    );
};

export default Suporte;

// Styled Components
const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background: #fff;
`;

const MainContent = styled.main`
    padding-top: 85px;
    padding-left: 260px;
    padding-right: 24px;
    padding-bottom: 60px;
    box-sizing: border-box;
    flex: 1 0 auto;
    @media (max-width: 1200px) and (min-width: 768px) {
        padding-left: 80px;
    }
    @media (max-width: 767px) {
        padding-left: 16px;
        padding-right: 16px;
        padding-bottom: 16px;
    }
`;

const Container = styled.div`
    padding: 24px;
    max-width: 1200px;
    margin: 0 auto;
    font-family: 'Roboto', sans-serif;
`;

const FiltrosContainer = styled.div`
    display: flex;
    gap: 24px;
    margin-bottom: 32px;
    @media (max-width: 768px) {
        flex-direction: column;
        gap: 16px;
    }
`;

const FiltroGroup = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 200px;
`;

const Label = styled.label`
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    font-size: 16px;
`;

const Select = styled.select`
    padding: 8px 16px;
    border: 1px solid #008080;
    background-color: white;
    color: #008080;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    outline: none;
    transition: all 0.15s ease;

    &:hover {
        background: #008080;
        color: #fff;
    }

    &:focus {
        box-shadow: none;
    }
    
    option {
        background-color: #fff !important;
        color: #333 !important;
    }
`;

const MensagemContainer = styled.div`
    background: #fff;
    border: 1px solid #008080;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    padding: 24px;
`;

const AssuntoContainer = styled.div`
    margin-bottom: 24px;
`;

const AssuntoLabel = styled.h3`
    font-size: 18px;
    font-weight: 600;
    color: #008080;
    margin-bottom: 8px;
`;

const AssuntoText = styled.div`
    font-size: 16px;
    color: #333;
    font-weight: 500;
`;

const RespostaContainer = styled.div``;

const RespostaLabel = styled.h3`
    font-size: 18px;
    font-weight: 600;
    color: #008080;
    margin-bottom: 16px;
`;

const RespostaText = styled.div`
    font-size: 16px;
    color: #333;
    line-height: 1.6;
    white-space: pre-line;
`;

const RespostaHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
`;

const CopyButton = styled.button`
    background: #fff;
    border: 1px solid #008080;
    color: #008080;
    padding: 6px 12px;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
    &:hover {
        background: #008080;
        color: #fff;
    }
`;
